module.exports = __webpack_public_path__ + "static/media/cockroach(8).5f06de20.PNG";